// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"90":"930557f4","584":"20ae1592"}[chunkId] + ".chunk.js";
};